<template>
	<div>
		<div class="gPageBorder">
			<el-row style="margin-bottom:24px">

				<el-col :span="12" style="">
					<!-- <el-button v-show='isCerUpload' class='gSgLeftBtn' type="primary" @click="uploadCer">
						{{$t('app_upload')}}{{$t('lin_global.zhengshu')}}
					</el-button> -->
				</el-col>


				<el-col :span="4" :offset="16">
					<div class='gCtrl'>
						<MechanismSelector style='' :data="mechanismData"></MechanismSelector>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_serialnumber')" v-model='select_form.terminalNo'
							@keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
					</div>
				</el-col>

			</el-row>
			<el-table class='' v-loading="loading" :data="tableData2" id="tp" border style="margin-bottom: 20px;">

				<el-table-column prop="terminalNo" :label="$t('app_serialnumber')">

				</el-table-column>
				<el-table-column prop="terminalModel" :label="$t('lin_global.label_model')" width="">
				</el-table-column>
				<el-table-column prop="mechName" :label="$t('lin_global.label_areaid')">

				</el-table-column>
				<el-table-column prop="status" :label="$t('app_authstat')" :formatter="formatStatus"
					:show-overflow-tooltip="true" width="150">
					<template slot-scope="scope">
						<span>{{ formatStatus(scope.row) }}</span>
					</template>
				</el-table-column>

				<!-- <el-table-column header-align='center' align='center' prop="activationCode" :label="$t('app_authcode')"
					width="">
				</el-table-column> -->
				<el-table-column   prop="opeUser" :label="$t('app_operator')">
				</el-table-column>
				<el-table-column header-align='center' align='center' prop="opeTime" width='176'
					:label="$t('app_opetime')">
				</el-table-column>
				<!-- <el-table-column align='left' :label="$t('lin_global.ope')" width="110">
					<template slot-scope="scope">

						<el-tooltip class="item" effect="dark" :content="$t('lin_global.jh')" placement="top">
							<el-button type='text' v-show="scope.row.status == 2 ? true : false"
								@click.stop="actRow(scope.row)">
								{{ $t('lin_global.jh') }}
							</el-button>
						</el-tooltip>



					</template>
				</el-table-column> -->
			</el-table>
			<div class="gPgDiv" v-if="totalRecords > 0">
				<el-pagination style='' class='gPg' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
				</el-pagination>
			</div>
		</div>
		<el-dialog class='gDia' :title="$t('lin_global.xiafa')" v-model="xiafaVisible">
			<el-form class='gDiaTable' ref="addForm" :model="form" :rules="rules" label-width="22.5%">
				<el-form-item :label="$t('lin_global.certificateName')">
					{{zhengshu}}
				</el-form-item>
				<el-form-item :label="$t('lin_global.qudaoshangxinxi')">
					{{qudaoshangxinxi}}
				</el-form-item>
				<!--<el-form-item :label="$t('lin_global.label_areaid')" prop="distributorId">
        <el-select id="mechanismId" v-model="form.distributorId" filterable clearable :placeholder="$t('lin_global.place_areaid')" style="width:100%">
          <el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">
          </el-option>
        </el-select>
      </el-form-item>-->
				<el-form-item :label="$t('lin_global.tslxxx')">
					<el-select @change="changeType" filterable clearable v-model="form.pushType" style="width:100%">
						<el-option v-for="item in type" :key="item.typeid" :label="item.typename" :value="item.typeid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="isShow" :label="$t('lin_global.label_areaid')" prop="terminalNo">
					<el-select filterable clearable v-model="form.terminalNo"
						:placeholder="$t('lin_global.place_areaid')" style="width:100%">
						<el-option v-for="item in areaList" :key="item.mechanismid" :label="item.mechanismname" :value="item.mechanismid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="!isShow" :label="$t('lin_global.label_no')" prop="terminalNo">
					<!--<el-input v-model="form.terminalNo"></el-input>-->
					<AutoTerno @on-result-change="onDvInputChange"></AutoTerno>
					<!-- <el-autocomplete
          class="inline-input"
          style="width: 100%"
          v-model="form.terminalNo"
          :fetch-suggestions="querySearch">
        </el-autocomplete> -->
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="isSubmit" style="margin-right: 74%;" @click="xiafaSubmit">
						{{$t('lin_global.xiafa')}}
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import city from '../city.js'
	// import sFile from 'save-file'
	import AutoTerno from '../global/TernoAutoCtrl'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		components: {
			AutoTerno,
			MechanismSelector
		},
		data() {
			var that = this
			return {
				orderName: '',
				orderType: '',
				mechanismData: {
					callback(value) {
						that.select_form.merchantId = value
						that.query()
					}
				},
				select_form: {
					terminalNo: "",
					onlineStatus: "",
					status: "",
					merchantId: ""
				},
				mech: '',
				net_list: [{
						vl: "0",
						lb: this.$t('lin_global.new_add'),
						type: "gray"
					},
					{
						vl: '1',
						lb: this.$t('lin_global.online'),
						type: "success"
					},
					{
						vl: '2',
						lb: this.$t('lin_global.offline'),
						type: "danger"
					},
					{
						vl: '3',
						lb: this.$t('app_sleep'),
						type: "",
						color: "#FECC0B"
					}
				],
				status_list:[
					{
						vl:"0"
					},
					{
						vl: '1',
						lb: this.$t('auth_status_list.status_1')
					},
					{
						vl: '2',
						lb: this.$t('auth_status_list.status_2')
					},
					{
						vl: '3',
						lb: this.$t('auth_status_list.status_3')
					},
					{
						vl: '4',
						lb: this.$t('auth_status_list.status_4')
					},
					{
						vl: '5',
						lb: this.$t('auth_status_list.status_5')
					},
					{
						vl: '6',
						lb: this.$t('auth_status_list.status_6')
					}
				],
				dest_list: [{
						vl: '1',
						lb: this.$t('lin_global.normal')
					},
					{
						vl: '2',
						lb: this.$t('app_selfDestroy')
					}
				],
				ctype: '',
				queryKey: '',
				ahref: '',
				form: {
					pushType: '2',
					terminalNo: '',
					type: '',
					zl: 'XZZS',
					certificateId: ''
				},
				rules: {
					'terminalNo': [{
						required: true,
						message: this.$t('lin_global.quorter')
					}]
				},
				type: [{
					typename: this.$t('lin_global.label_areaid'),
					typeid: '2'
				}, {
					typename: this.$t('lin_global.shebei'),
					typeid: '1'
				}],
				sel: [],
				sel2: [],
				options: city,
				focusEvent: focusEvent,
				riskId: '',
				radius: '',
				citys: '',
				radius2: '',
				citys2: '',
				input1: '',
				value1: '',
				areaList1: [],
				ifshow: true,
				ifshow2: true,
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogTopMgVisible: false,
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				currentPage1: 1,
				pageSize1: 10,
				totalRecords1: 0,
				areaList: [],
				arrdata1: [],
				tableData2: [],
				xiafaVisible: false,
				zhengshu: '',
				qudaoshangxinxi: '',
				qudaoshangid: '',
				zhengshutype: '',
				isShow: true,
				isSubmit: false,
				restaurants: [],
				loading: true,
			}
		},
		created() {
			this.getData(1);
			// this.getData1(1, '', '');
			// this.getAd1();
		},
		methods: {
			query() {
				this.getData(this.currentPage)
			},
			onDvInputChange(vl) {
				//this.value1 = vl

				this.form.terminalNo = vl
			},
			rowClick: function(row, ev, col) {
				if (!col.label || col.label === this.$t('app_operate')) {
					return
				}

				this.$router.push({
					path: '/authorization-detail',
					query: {
						terminalNo: row.terminalNo,
					}
				})
			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					var boo = (restaurant.value.indexOf(queryString) === 0)
					return boo;
				};
			},
			getNoList: function() {
				var params = {
					mechId: this.qudaoshangid
				};
				axios.post(`${baseurl}/terminal/terminalNoList.do`, params).then(res => {
					console.log('r', res.data.data)
					this.restaurants = res.data.data;
				})
			},
			changeType: function() {
				this.form.terminalNo = '';
				if (this.form.pushType == '2') {
					this.isShow = true
				} else {
					this.isShow = false
				}
			},
			formatNetwork: function(row, column) {
				let result = row.terminalStatus ? this.net_list[row.terminalStatus] : {
					vl: "",
					lb: "",
					type: ""
				}
				return result
			},

			formatStatus: function(row, column) {
				let result = row.status ? this.status_list[row.status].lb : ""
				return result
			},
			cityFormat: function(row) {
				if (row.city) {
					var value = row.city.split(',')[0];
					return value
				}

			},
			hasValue: function(result, v, name) {
				if (!v[name] || v[name] === "") {
					return true;
				}
				return result.some((re) => v[name] === re);
			},
			selEvent: function(val) {

				var result = val.toString().split(',');
				var arr = this.options.filter(v => {
					if (this.hasValue(result, v, "value")) {
						if (v.children && v.children.length > 0) {
							v.children = v.children.filter(child => {
								if (this.hasValue(result, child, "value")) {
									return child
								}
								return false;
							});
							return v
						} else {
							return v
						}
					}
				})
				//console.log("打印城市")
				//console.log(arr);
				if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0]
					.value === "500000") {
					this.citys = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
				} else {
					this.citys = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[
						0].value;
				}
				//alert(this.citys);
			},
			selEvent2: function(val) {

				var result = val.toString().split(',');
				var arr = this.options.filter(v => {
					if (this.hasValue(result, v, "value")) {
						if (v.children && v.children.length > 0) {
							v.children = v.children.filter(child => {
								if (this.hasValue(result, child, "value")) {
									return child
								}
								return false;
							});
							return v
						} else {
							return v
						}
					}
				})
				//console.log("打印城市")
				//console.log(arr);
				if (arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0]
					.value === "500000") {
					this.citys2 = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
				} else {
					this.citys2 = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[
						0].value;
				}
				//alert(this.citys);
			},
			getAd1: function() {
				var params = {
					page: 1,
					rows: 10000
				};


				/*axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
				  //console.log(res.data);
				  var obj={
				    'mechanismname':this.$t('lin_global.all_mechanism'),
				    'mechanismid':''
				  }
				  this.areaList1 = res.data.data;
				  if(this.areaList1){
				    this.areaList1.unshift(obj)
				  } 
				})*/
			},
			getData1(page, no, areaid) {

				this.currentPage1 = page;
				var params = {
					page: page,
					rows: this.pageSize1,
					areaid: areaid,
					terminal_no: no,
					terminal_status: '',
					terminal_runtime_status: ''
				}
				//console.log("打印传出参数");
				//console.log(params);
				axios.post(`${baseurl}/terminal/list.do`, params).then(res => {
					//console.log("打印返回列表");
					//console.log(res.data);
					this.arrdata1 = res.data.data;
					this.totalRecords1 = res.data.total;
				}).catch(function(error) {

				})
			},
			statusChange() {
				this.getData1(1, this.input1, this.value1)
			},
			handleIconClick() {
				this.getData1(1, this.input1, this.value1)
			},
			actRow: function(row) {
				console.log(row);
				var params = {
					terminalNo: row.terminalNo
				}
				this.$confirm(this.$t('app_isActive'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/terminal_auth/authentication.do`, params).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData(1);
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},
			deleteRow: function(id) {
				var params = {
					id: id
				}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/cer/deleteCertificate.do`, params).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData(1);
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},
			submit: function() {
				this.params = {};
				if (this.form.controlType == '0') {
					this.params.radius = this.radius;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				} else {
					this.params.city = this.citys;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				}
				//console.log("打印参数");
				//console.log(this.params);
				var params = this.params;
				axios.post(`${baseurl}/risk/addRisk.do`, params).then(res => {
					//console.log("打印看看登陆信息")
					//console.log(res.data);
					if (res.data.status == 200) {
						this.dialogFormVisible = false;
						this.$message.success(res.data.message);
						this.getData(1);
					} else {
						this.dialogFormVisible = false;
						this.$message.error(res.data.message)
					}
				})
			},
			onCancel: function() {
				this.dialogFormVisible = false;
			},
			onCancel2: function() {
				this.dialogFormVisible2 = false;
			},
			change: function() {
				if (this.form.controlType == '0') {
					this.ifshow = true;
				} else {
					this.ifshow = false;
				}
			},
			getAd: function() {
				/*this.$getChannelList(10000, 1, (res) => {
				  
				  this.areaList = res.data
				}, '') */

				var params = {
					page: 1,
					rows: 10000,
					mechId: this.qudaoshangid
				};
				axios.post(`${baseurl}/mechanism/list.do`, params).then(res => {
					//console.log(res)
					this.areaList = res.data.data;
				})
			},
			uploadCer() {
				this.$setWObj('safeCerType', 1)
				this.$router.push({
					path: '/certificate/upload'
				})
			},
			add: function() {
				this.$router.push({
					path: '/certificate/new'
				})
			},
			upload: function() {
				this.$router.push({
					path: '/certificate/upload'
				})
			},
			linkDetail: function(row) {
				//console.log(row.id)
				this.$router.push({
					path: '/rail/' + row.id + '/detail'
				})
			},
			handleSizeChange: function(val) {
				this.pageSize = val
				this.getData(this.currentPage)
			},
			handleCurrentChange: function(val) {
				this.currentPage = val
				this.getData(this.currentPage)
			},
			getData(page) {
				this.currentPage = page;
				var params2 = {
					page: page,
					rows: this.pageSize,
					...this.select_form
				};
				axios.post(`${baseurl}/terminal_auth/getActivationList.do`, params2).then(res => {
					console.log(res.data);
					if (res.data.status == 200) {
						this.tableData2 = res.data.data;
						this.totalRecords = res.data.total;
						this.loading = false;
					} else {
						this.loading = false;
					}

				})
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// recordList.vue?b849869c